import React from "react";
import { colors } from "../../constants/colors";
import familyPhoto from "../../images/future-genc.png";

export const Philosophy = () => {
  return (
    <section
      id="philosophy"
      data-aos="fade-down-right"
      className="philosophy container-fluid"
      style={{ backgroundColor: colors.gencWhite }}
    >
      <div className="philosophy-container">
        <div className="col-md-6 d-flex justify-content-center">
          <img src={familyPhoto} alt="FamilyPic" />
        </div>
        <div
          className="col-md-6 d-flex flex-column justify-content-center"
          style={{
            padding: "6vw",
          }}
        >
          <h1 style={{ color: colors.gencBlue, marginBottom: 0 }}>
            Delivering Health and Happiness
          </h1>
          <hr
            style={{
              width: "50%",
              height: "3px",
              textAlgin: "left",
              backgroundColor: colors.gencBlue,
              marginLeft: 0,
              marginTop: 2,
            }}
          />
          <p style={{ color: colors.gencBlack }}>
            <b>From the very first members to the future Generation C</b>, we
            are striving to build a delivering health and happiness culture that
            is conducive to health and wellbeing for all. So subscribe, tune in,
            and help us to serve you and the future Gen C.
          </p>
        </div>
      </div>
    </section>
  );
};
